'use client'

import { createContext, useContext } from 'react'
import {
  useChatkitScript,
  type IChatkitScriptState,
} from '@/app/chatkit/_components/chatkit-script-loader'

const ChatkitScriptContext = createContext<IChatkitScriptState | null>(null)

/**
 * Provider component that loads ChatKit script once at root level
 * and shares loading state across entire application
 */
export function ChatkitScriptProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const scriptState = useChatkitScript()

  return (
    <ChatkitScriptContext.Provider value={scriptState}>
      {children}
    </ChatkitScriptContext.Provider>
  )
}

/**
 * Hook to access ChatKit script loading state from context
 * @returns ChatKit script loading state
 * @throws Error if used outside of ChatkitScriptProvider
 */
export function useChatkitScriptContext(): IChatkitScriptState {
  const context = useContext(ChatkitScriptContext)
  if (!context) {
    throw new Error(
      'useChatkitScriptContext must be used within ChatkitScriptProvider',
    )
  }
  return context
}
